"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseController = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TrainerContext_1 = require("../TrainerContext");
const useTrainerSnapshot_1 = require("../hooks/useTrainerSnapshot");
const GameOverlay_1 = require("./GameOverlay");
const Modal_1 = require("./Modal");
const RuneScapeButton_1 = require("./RuneScapeButton");
const RuneScapePanel_1 = require("./RuneScapePanel");
function PauseController() {
    const trainer = (0, TrainerContext_1.useTrainerContext)();
    const paused = (0, useTrainerSnapshot_1.useTrainerSnapshot)((snapshot) => snapshot.world.isPaused);
    const pausedForBackground = (0, react_1.useRef)(false);
    const [resumeRequired, setResumeRequired] = (0, react_1.useState)(false);
    const pauseForBackground = (0, react_1.useCallback)(() => {
        if (trainer.getSnapshot().world.isPaused)
            return;
        pausedForBackground.current = true;
        trainer.stop();
    }, [trainer]);
    (0, react_1.useEffect)(() => {
        const onVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                pauseForBackground();
            }
            else if (pausedForBackground.current) {
                setResumeRequired(true);
            }
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        return () => document.removeEventListener("visibilitychange", onVisibilityChange);
    }, [pauseForBackground]);
    // Covers auto-start completing while the trainer was already backgrounded.
    (0, react_1.useEffect)(() => {
        if (!paused && document.visibilityState === "hidden")
            pauseForBackground();
    }, [pauseForBackground, paused]);
    const resume = () => {
        pausedForBackground.current = false;
        setResumeRequired(false);
        trainer.start();
    };
    return ((0, jsx_runtime_1.jsx)(GameOverlay_1.GameOverlay, { children: (0, jsx_runtime_1.jsx)(Modal_1.Modal, { open: resumeRequired, children: (0, jsx_runtime_1.jsxs)(RuneScapePanel_1.RuneScapePanel, { style: { maxWidth: 360, textAlign: "center" }, children: [(0, jsx_runtime_1.jsx)("p", { style: { margin: "0 0 16px" }, children: "Paused" }), (0, jsx_runtime_1.jsx)(RuneScapeButton_1.RuneScapeButton, { autoFocus: true, onClick: resume, type: "button", children: "Resume" })] }) }) }));
}
exports.PauseController = PauseController;
